import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "./ThemeContext";
import ScrollToTop from "./component/ScrollToTop";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Tokenization from "./pages/Tokenization";
import Partners from "./pages/Partners";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Header from "./component/Header";
import Footer from "./component/Footer";
import DefiDevelopment from "./pages/DefiDevelopment";
import SmartContract from "./pages/SmartContract";
import BlockchainDevelopment from "./pages/BlockchainDevelopment";
import Metaversedevelopment from "./pages/Metaversedevelopment";
import Web3Development from "./pages/Web3Development";
import TokenCoin from "./pages/TokenCoin";
import CryptoCurrency from "./pages/CryptoCurrency";
import Career from "./pages/Career";
import Exchange from "./pages/Exchange";
import NftMarketplace from "./pages/NftMarketplace";
import AiDevelopment from "./pages/AiDevelopment";
import BotDevelopment from "./pages/BotDevelopment";
import Gaming from "./pages/Gaming";
import ScrollTop from "./component/ScrollTop";
import ProductDetails from "./pages/ProductDetails";
import NotFound from "./pages/NotFound";


const Layout = () => {
  return (
    <>
      <Header />
      <ScrollTop />
      <ScrollToTop>
        <Outlet />
      </ScrollToTop>
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />
      <ThemeProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" index element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/exchange" element={<Exchange />} />
            <Route path="/about" element={<About />} />
            <Route path="/tokenization" element={<Tokenization />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/defi" element={<DefiDevelopment />} />
            <Route path="/smartcontract" element={<SmartContract />} />
            <Route path="/blogdetails" element={<BlogDetails />} />
            <Route
              path="/blockchain_development"
              element={<BlockchainDevelopment />}
            />
            <Route
              path="/metaverse_development"
              element={<Metaversedevelopment />}
            />
            <Route path="/web3development" element={<Web3Development />} />
            <Route path="/tokencoin" element={<TokenCoin />} />
            <Route path="/cryptocurrency" element={<CryptoCurrency />} />
            <Route path="/career" element={<Career />} />
            <Route path="/nftmarketplace" element={<NftMarketplace />} />
            <Route path="/aidevelopment" element={<AiDevelopment />} />
            <Route path="/botdevelopment" element={<BotDevelopment />} />
            <Route path="/gaming" element={<Gaming />} />
            <Route path="/productdetails" element={<ProductDetails />} />
          </Route>
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
